GameView    = require "views/base/game"
{ AutoCursorRemoveDraggy }  = require("views/components/draggy")

class CarouselView extends GameView
  template: require("./template")

  currentIndex: 0

  events:
    "iostap .btn-done": "endGame"
    "iostap .page": "onClickDot"

  serialize: ->
    data = super

    { randomize } = data

    # We read the data from the metadata associated with the slide
    # To get the answer Ids and track them
    answers = (data.metadata.questions?[0]?.answers or []).map (a) ->
      content: a.content or "", correct: a.correct, id: a.id

    answers = answers.filter (m) -> m.content?
    answers = answers.reverse() if @options.config().direction is "rtl"
    answers = _.shuffle(answers) if randomize

    data.answers = answers
    data

  show: (index = 0) ->
    super
    el = @findOne(".carousel")

    @setEl @findOne(".pagination"), "pagination"
    @setEl el.firstChild, "scroller"

    ln  = @serialize().answers.length
    min = -el.offsetWidth * (ln - 1)

    @draggy  = new AutoCursorRemoveDraggy 
      el: el
      minX: min
      maxX: 0
      lock: "y"

    @listenTo @draggy, "drag", @onDrag
    @listenTo @draggy, "drop", @onDrop
    @listenTo this, "resize", @onResize

    if @options.config().direction is "rtl"
      x = -@draggy.el.offsetWidth * (ln - 1 - index)
    else
      x = -@draggy.el.offsetWidth * index

    @draggy.reset { x }
    @onResize()

    @enterGame()

  onDrag: (draggy, isInitial) ->
    @transform @getEl("scroller"),
      x: @getScrollDist(draggy)
      transition: if isInitial then "all 300ms" else ""

    @updateChildren(draggy, isInitial and "none")

  onDrop: (draggy, isReset) ->
    if isReset
      transition    = if @currentIndex? then "all 300ms" else ""
      # Round down to avoid any decimal error. Draggy is not consistent
      @currentIndex = Math.floor(-Math.floor(draggy.x) / Math.floor(draggy.offset.width))

      @setState @currentIndex, "page"


      for child, i in @getEl("pagination").children
        child.classList.toggle("active", i is @currentIndex)

      @transform @getEl("scroller"),
        x: @getScrollDist(draggy)
        transition: transition

      @updateChildren(draggy, transition)

    else
      x = draggy.velocity.x
      m = 0.9
      func =
        if x < -m then "ceil"
        else if x > m then "floor"
        else "round"

      step = Math[func](Math.min(draggy.x / draggy.offset.width, 1))

      draggy.reset x: step * draggy.offset.width

      @setState("touched") if @currentState.state is "prompt"
  
  onClickDot: (e) ->
    index = e.currentTarget.dataset.page
    total = @options.data.answers.length - 1
    @draggy.reset x: (index / total) * @draggy.options.minX
    @setState("touched")

  updateChildren: (draggy, transition) ->
    { width } = draggy.offset

    for child, i in @getEl("scroller").children
      return unless button = child.querySelector(".btn")

      if transition
        child.classList.toggle("active", i is @currentIndex)
        @transition(button, transition, true)

      @transform button,
        scale: 1 - Math.abs(draggy.x + (i * width)) / width / 5
        opacity: 1 - Math.abs(draggy.x + (i * width)) / width

  getScrollDist: (draggy) ->
    "#{
      draggy.x / draggy.offset.width / @options.data.answers.length * 100
    }%"

  answerDetails: ->
    questions    = @options.metadata?.questions or []
    return [] unless questions.length > 0

    question = questions[0]
    selectedAnswerId =
      $(@getEl("scroller")?.children[@currentIndex or 0]).data("answer-id")
    answer = _.find question.answers, (a) -> a.id is selectedAnswerId
    details = question: question.question, answer: answer
    [ details ]

  isCorrect: ->
    @getEl("scroller")?.children[@currentIndex or 0].dataset.isCorrect?

  onResize: ->
    if scroller = @getEl("scroller")
      @draggy?.options.minX =
        -@draggy.el.offsetWidth * (@options.data.answers.length - 1)

      scroller.style.height = ""
      height = scroller.offsetHeight
      scroller.style.height = "#{height}px"
      height

  refresh: (params) ->
    for { content }, i in params.data.answers
      changed = i if content and @options.data.answers[i]?.content isnt content

    super

    @currentIndex = null
    @show(changed)

  endGame: ->
    super

    @submit()

module.exports = CarouselView
